module.exports = __webpack_public_path__ + "static/img/icon1.177d4bf5.png";